import { useMemo } from 'react';
import { ClassesToApplyType, topNavOffsetClassesGetter } from '../helpers/topNavOffsetClasses';
import { useUserData } from './useUserData';
import { TopNavStateType } from '../providers/TopNavProvider';

export const useTopNavClasses = (topNavOffsetState: TopNavStateType): ClassesToApplyType => {
  const { userData } = useUserData();

  const organizations: number = useMemo(() => {
    if (userData) {
      return userData.organizations.reduce((prev, current) => prev + current.workspaces.length, 0);
    }
    return 0;
  }, [userData]);

  return useMemo(
    () => topNavOffsetClassesGetter(topNavOffsetState.visibility, organizations),
    [organizations, topNavOffsetState]
  );
};
